let mapInterval;
export function resetMapInterval() {
    window.clearInterval(mapInterval);
}
export function rememberMapInterval(interval) {
    mapInterval = interval;
}
export function getMapInterval() {
    return mapInterval;
}
